import path from 'path';
export const getRollupTypescriptConfig = ({ options, pkg, resolvedSource, tsconfigPath, }) => {
    const declarationOptions = pkg.types
        ? {
            emitDeclarationOnly: true,
            declaration: true,
            declarationDir: path.resolve(options.cwd, path.dirname(pkg.types)),
        }
        : {};
    return {
        tsconfig: tsconfigPath ?? false,
        rootDir: resolvedSource ? path.dirname(resolvedSource) : undefined,
        sourceMap: false,
        exclude: [
            '**/__tests__/**',
            '**/*.test.*',
            '**/*.spec.*',
            '**/*.stories.*',
            '**/*.mock.*',
        ],
        ...declarationOptions,
    };
};
